export interface AuthUser {
  id: number;
  name: string;
  username: string;
  email?: string;
  roles?: string[] | Array<{ name: string }>;
  permissions?: string[];
}

function roleNames(user: AuthUser | null | undefined): string[] {
  const roles = user?.roles ?? [];
  if (roles.length === 0) return [];
  if (typeof roles[0] === 'string') return roles as string[];
  return (roles as Array<{ name: string }>).map((r) => r.name);
}

export function hasPermission(user: AuthUser | null | undefined, permission: string): boolean {
  if (!user) return false;
  if (roleNames(user).includes('super-admin')) return true;
  return (user.permissions ?? []).includes(permission);
}

export function hasAnyPermission(user: AuthUser | null | undefined, permissions: string[]): boolean {
  return permissions.some((p) => hasPermission(user, p));
}

export function hasModuleAccess(user: AuthUser | null | undefined, moduleAlias: string): boolean {
  if (!user) return false;
  if (roleNames(user).includes('super-admin')) return true;
  const accessPermission = `access-${moduleAlias}`;
  if (hasPermission(user, accessPermission)) return true;
  return (user.permissions ?? []).some((p) => p.includes(moduleAlias));
}

export function canPerformAction(
  user: AuthUser | null | undefined,
  resource: string,
  action: 'view' | 'create' | 'edit' | 'delete'
): boolean {
  return hasAnyPermission(user, [
    `${action}-${resource}`,
    `manage-${resource}`,
  ]);
}
